import { CircularProgress, IconButton, Tooltip, withStyles } from "@material-ui/core";
import { Info } from "@material-ui/icons";
import React from "react";
import { useAppDataProvider } from "../../../../../dataprovider";
export const RequirementCategoryToolTip = props => {
  const { record, source } = props;
  const [qty, setQty] = React.useState<any>(null);
  const [loading, setLoading] = React.useState<any>(false);
  const dataProvider = useAppDataProvider();

  const getQty = async () => {
    if (
      loading == true ||
      (qty?.pn == record?.pn && qty?.contractNumber == record?.contractId && qty?.customerCode == record?.customerCode)
    ) {
      return;
    }
    setLoading(true);
    dataProvider
      .getHomeBaseQtyInfoForList({
        contractNumber: record?.contractId,
        customerCode: record?.customerCode,
        pn: record?.pn,
      })
      .then(response => {
        if (response?.data?.data) {
          var data = response.data.data;
          setQty(data);
        } else {
          setQty(null);
        }
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <>{record[source]}</>

      <HtmlTooltip
        title={
          loading ? (
            <CircularProgress size="2rem" color="primary" />
          ) : (
            `Qty : ${qty?.homebasePnQty ?? 0} + Request : ${qty?.requestQty ?? 0} = Total : ${(qty?.homebasePnQty ?? 0) + (qty?.requestQty ?? 0)} `
          )
        }
      >
        <IconButton onMouseOver={getQty}>
          <Info />
        </IconButton>
      </HtmlTooltip>
    </div>
  );
};

export default RequirementCategoryToolTip;
const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);
